import script from "./ShareDialog.vue?vue&type=script&setup=true&lang=js"
export * from "./ShareDialog.vue?vue&type=script&setup=true&lang=js"

import "./ShareDialog.vue?vue&type=style&index=0&id=1ac1dac9&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1ac1dac9"]])

export default __exports__